export enum PresentationStatus {
  PLANNED = "PLANNED",
  DANCING = "DANCING",
  DONE = "DONE",
  REMOVED = "REMOVED",
}

export const normalizePresentationStatus = (
  status: PresentationStatus | string | null | undefined,
): PresentationStatus => {
  if (status === PresentationStatus.DANCING) {
    return PresentationStatus.DANCING;
  }
  if (status === PresentationStatus.DONE) {
    return PresentationStatus.DONE;
  }
  if (status === PresentationStatus.REMOVED) {
    return PresentationStatus.REMOVED;
  }
  return PresentationStatus.PLANNED;
};
